import { render } from "./MultiChoice.vue?vue&type=template&id=2ef82591&scoped=true&ts=true"
import script from "./MultiChoice.vue?vue&type=script&lang=ts"
export * from "./MultiChoice.vue?vue&type=script&lang=ts"

import "./MultiChoice.vue?vue&type=style&index=0&id=2ef82591&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ef82591"]])

export default __exports__